export const capitaliseFirstLetter = (text: string): string =>
  text.charAt(0).toUpperCase() + text.substr(1)

/** Checks if an iterable item is undefined or empty */
export const isUndefinedOrEmpty = <T extends { length: number }>(item?: T): boolean =>
  !item || item.length === 0

export const decimalToFractionStr = (decimalVal: number) => {
  const isNumber = !isNaN(decimalVal)
  if (!isNumber) return decimalVal
  if (decimalVal % 1 === 0) return decimalVal
  const tolerance = 0.0001
  let num = 1,
    den = 1

  const iterate = () => {
    var R = num / den
    if (Math.abs((R - decimalVal) / decimalVal) < tolerance) return

    if (R < decimalVal) num++
    else den++
    iterate()
  }

  iterate()
  return `${num}/${den}`
}
